import config from '../../../config';

// Build-time API_GATEWAY_ENDPOINT wins; the fallback is the dev API Gateway stage.
const rawApiBaseUrl: string =
  config.API_GATEWAY_ENDPOINT || 'https://bkh8s2bs8c.execute-api.eu-west-1.amazonaws.com/dev';

// Remove a trailing dot (and any trailing slash) so endpoint URLs are well-formed.
export const API_BASE_URL: string = rawApiBaseUrl.replace(/[./]+$/, '');

export const API_ENDPOINTS = {
  audits: `${API_BASE_URL}/audits`,
  audit: (auditId: string) => `${API_BASE_URL}/audits/${encodeURIComponent(auditId)}`,
  auditPeerReview: (auditId: string) => `${API_BASE_URL}/audits/${encodeURIComponent(auditId)}/peer-review`,
  templates: `${API_BASE_URL}/templates`,
  template: (templateId: string | number) => `${API_BASE_URL}/templates/${encodeURIComponent(templateId)}`,
  templateQuestionPreview: `${API_BASE_URL}/templates/question-preview`,
  templateSections: `${API_BASE_URL}/templates/sections`,
  templateSectionQuestions: (sectionId: string | number) =>
    `${API_BASE_URL}/templates/sections/${encodeURIComponent(sectionId)}/questions`,
  suppliers: `${API_BASE_URL}/suppliers`,
  supplier: (supplierId: string | number) => `${API_BASE_URL}/suppliers/${encodeURIComponent(supplierId)}`,
  supplierSearch: `${API_BASE_URL}/suppliers/search`,
  users: `${API_BASE_URL}/users`,
} as const;
